const getDefaultStateUtenzePromoter = () => {
  return {
    utenzaUtenzePromoter: null,
    cognomeUtenzePromoter: null,
    emailUtenzePromoter: null,
    rowsToSkipUtenzePromoter: 0,
    fetchRowsUtenzePromoter: 25,
    currentPageUtenzePromoter: 1,
    sortColumnUtenzePromoter: "promoter",
    sortOrderUtenzePromoter: "asc",
  };
};
const state = getDefaultStateUtenzePromoter();

const getters = {
  utenzaUtenzePromoter: (state) => state.utenzaUtenzePromoter,
  emailUtenzePromoter: (state) => state.emailUtenzePromoter,
  cognomeUtenzePromoter: (state) => state.cognomeUtenzePromoter,
  rowsToSkipUtenzePromoter: (state) => state.rowsToSkipUtenzePromoter,
  fetchRowsUtenzePromoter: (state) => state.fetchRowsUtenzePromoter,
  currentPageUtenzePromoter: (state) => state.currentPageUtenzePromoter,
  sortColumnUtenzePromoter: (state) => state.sortColumnUtenzePromoter,
  sortOrderUtenzePromoter: (state) => state.sortOrderUtenzePromoter,
};

// const actions = {};
const mutations = {
  setUtenzaUtenzePromoter: (state, value) => {
    state.utenzaUtenzePromoter = value;
  },
  setEmailUtenzePromoter: (state, value) => {
    state.emailUtenzePromoter = value;
  },
  setCognomeUtenzePromoter: (state, value) => {
    state.cognomeUtenzePromoter = value;
  },
  setFetchRowsUtenzePromoter: (state, value) => {
    state.currentPageUtenzePromoter = 1;
    state.rowsToSkipUtenzePromoter = 0;
    state.fetchRowsUtenzePromoter = value;
  },
  setCurrentPageUtenzePromoter: (state, value) => {
    state.currentPageUtenzePromoter = value;
    state.rowsToSkipUtenzePromoter = parseInt(
      (state.currentPageUtenzePromoter - 1) * state.fetchRowsUtenzePromoter
    );
  },
  setSortColumnUtenzePromoter: (state, value) => {
    state.sortColumnUtenzePromoter = value;
  },
  setSortOrderUtenzePromoter: (state, value) => {
    state.sortOrderUtenzePromoter = value;
  },
  setCategoriaUtenzePromoter: (state, value) => {
    state.id_categoriaUtenzePromoter = value;
  },
  resetFiltersUtenzePromoter: (state) => {
    Object.assign(state, getDefaultStateUtenzePromoter());
  },
  resetRowsToSkipUtenzePromoter: (state) => {
    state.currentPageUtenzePromoter = 1;
    state.rowsToSkipUtenzePromoter = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
